import React from 'react';

import Room from '../room';

import G1 from './images/garden.2.jpg';
import G2 from './images/garden.4.jpg';
import G3 from './images/garden.6.jpg';
import G4 from './images/garden.8.jpg';
import G5 from './images/garden.10.jpg';
import G6 from './images/garden.14.jpg';
import G7 from './images/garden.17.jpg';
import G8 from './images/garden.20.jpg';

const StandardGarden = () => {

  const images = [
    { original: G1, thumbnail: G1},
    { original: G2, thumbnail: G2},
    { original: G3, thumbnail: G3},
    { original: G4, thumbnail: G4},
    { original: G5, thumbnail: G5},
    { original: G6, thumbnail: G6},
    { original: G7, thumbnail: G7},
    { original: G8, thumbnail: G8},
  ]

  return (
    <Room title="Standard Garden" images={images} capacity={4}>
      <p className="p-services">Habitaciones modernas, pensadas como parte integrada de nuestro patio… Ubicadas frente a la piscina, entre el verde y el agua.</p>
      <p className="p-services">Equipada con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default StandardGarden;


// WEBPACK FOOTER //
// ./src/rooms/standard-garden/index.js